import { Capacitor } from '@capacitor/core';

// Thin platform helpers. Everything native-only in the app is gated through these so the website
// build behaves exactly as before (isNative() === false on web).

export type NativePlatform = 'ios' | 'android' | 'web';

export const isNative = (): boolean => Capacitor.isNativePlatform();

export const getPlatform = (): NativePlatform => {
  const p = Capacitor.getPlatform();
  return p === 'ios' || p === 'android' ? p : 'web';
};

export const isIOS = (): boolean => getPlatform() === 'ios';
export const isAndroid = (): boolean => getPlatform() === 'android';
